"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { clsx } from 'clsx';
import { Children, isValidElement, cloneElement } from 'react';
import { tv } from 'tailwind-variants';

const iconVariants = tv({
  base: "inline-block shrink-0 align-middle leading-none text-current",
  variants: {
    size: {
      xs: "w-3 h-3",
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6",
      xl: "w-7 h-7",
      "2xl": "w-8 h-8"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const Icon = ({ children, className, size, ...props }) => {
  const child = Children.only(children);
  if (!isValidElement(child)) return null;
  const childClassName = child.props?.className;
  return cloneElement(child, {
    ...props,
    className: iconVariants({ size, className: clsx(childClassName, className) })
  });
};

export { Icon };
